import { derived } from "svelte/store";
import en from '../constants/copy.en';
import fr from '../constants/copy.fr';
import es from '../constants/copy.es';
import { type Language, languageStore } from '../stores/language';
import intlEN from '../constants/intlCopy.en';
import intlES from '../constants/intlCopy.es';
import { isPrimaryCampaign } from "../constants/countries";

// Setting it to typeof EN will make sure that the copy object has the same structure as the EN object.
// Typescript will complain otherwise. That's why we want to keep these files using .ts
export type Copy = typeof en;
export const copyMap: Record<Language, Copy> = { en, fr, es };
const intlCopyMap: Record<Language, Copy> = { en: intlEN, es: intlES, fr: intlES };

// Setting a default, just in case it so happens that the language is something not supported for some reason.
export const copy = derived([languageStore], ([$language]) => {
  const language = $language || 'en';
  return isPrimaryCampaign ? copyMap[language]() : intlCopyMap[language]();
});
